import { useEffect } from 'react';
import { Linking } from 'react-native';
import { useSelector } from 'react-redux';
import i18n from 'i18n-js';

import { initNotification, logNeedUpdateApp, logWarnToUpdateApp } from '@reducers/notification';
import { selectCurrentUserId } from '@reducers/user';
import { Alert, isAndroid, getSecureValue } from '@helpers';
import { APP_STORE_URL, PLAY_STORE_URL } from '@v2/pages/common/constants/base.constants';
import { selectWarnToUpdateApp, selectNeedUpdateApp, selectIsServerWorking } from '@reducers/notification';
import { useAppDispatch } from '@store/hooks/useAppDispatch';

export const useManageNotificationSystem = () => {
  const dispatch = useAppDispatch();

  const warnToUpdateApp = useSelector(selectWarnToUpdateApp);
  const needUpdateApp = useSelector(selectNeedUpdateApp);
  const isServerWorking = useSelector(selectIsServerWorking);

  const goToPlayStoreConfig = {
    text: isAndroid ? 'Go to Play Store' : 'Go to App Store',
    onPress: () => Linking.openURL(isAndroid ? PLAY_STORE_URL : APP_STORE_URL),
  };

  const currentUserId = useSelector(selectCurrentUserId);

  useEffect(() => {
    if (!getSecureValue('token')) {
      return;
    }
    dispatch(initNotification());
  }, [currentUserId]);

  useEffect(() => {
    if (!isServerWorking) {
      console.log(isServerWorking, 'isServerWorking');
      Alert({ title: i18n.t('The Smart Factory Cloud is unable to process your request at this time'), text: i18n.t('Please try again later') });
    }
  }, [isServerWorking]);

  useEffect(() => {
    if (warnToUpdateApp) {
      Alert({
        title: i18n.t('A newer version of the app is available'),
        text: i18n.t('Please update the app to get the latest features and fixes.'),
        actions: [
          { text: 'Close', onPress: () => {}, style: 'secondary' },
          { text: goToPlayStoreConfig.text, onPress: goToPlayStoreConfig.onPress, style: 'primary' },
        ],
        position: 'vertical',
        boldPrimary: true,
      });
    }
  }, [warnToUpdateApp]);

  useEffect(() => {
    if (warnToUpdateApp && currentUserId) {
      dispatch(logWarnToUpdateApp());
    }
  }, [warnToUpdateApp, currentUserId]);

  useEffect(() => {
    if (needUpdateApp && currentUserId) {
      dispatch(logNeedUpdateApp());
    }
  }, [needUpdateApp, currentUserId]);

  return { needUpdateApp, goToPlayStoreConfig };
};
